import { FC } from 'react'
import MyModal, { IMyModal } from 'src/components/ui/modal/MyModal'
import { IProperty } from 'src/interfaces/IProperty'
import { ImageGallery, MapView, PropertyDetails, PropertyInfo } from './components'

interface IAnnouncementModal extends IMyModal {
  property: IProperty
}

const AnnouncementModal: FC<IAnnouncementModal> = ({ open, handleClose, property }) => {
  return (
    <MyModal showClose={false} open={open} handleClose={handleClose}>
      <div className="flex flex-col md:flex-row gap-6">
        <div className="flex flex-col max-w-[40.625rem] w-full">
          <div className="flex flex-col gap-[2.0625rem] md:sticky md:top-0">
            <ImageGallery images={property.images || []} />
            <PropertyInfo property={property} />
          </div>
        </div>
        <div className="flex flex-col max-w-[36.5rem]">
          <PropertyDetails property={property} handleClose={handleClose} />
          <MapView
            latitude={property.location?.coordinates?.[1]}
            longitude={property.location?.coordinates?.[0]}
          />
        </div>
      </div>
    </MyModal>
  )
}

export default AnnouncementModal
